export const CountriesEnum = [
	{ locale: 'nl-nl', languageCode: 'nl', countryCode: 'NL', languageName: 'Nederlands (NL)', regionName: 'Nederland' },
	{ locale: 'nl-be', languageCode: 'nl', countryCode: 'BE', languageName: 'Nederlands (BE)', regionName: 'Vlaanderen' },
	{ locale: 'en', languageCode: 'en', countryCode: null, languageName: 'English' },
	{ locale: 'es', languageCode: 'es', countryCode: 'ES', languageName: 'Español' },
	{ locale: 'fr', languageCode: 'fr', countryCode: 'FR', languageName: 'Français' },
	{ locale: 'de', languageCode: 'de', countryCode: 'DE', languageName: 'Deutsch' },
	{ locale: 'it', languageCode: 'it', countryCode: 'IT', languageName: 'Italiano' },
	{ locale: 'sv', languageCode: 'sv', countryCode: 'SE', languageName: 'Svenska' },
	{ locale: 'no', languageCode: 'no', countryCode: 'NO', languageName: 'Norsk' },
	{ locale: 'da', languageCode: 'da', countryCode: 'DK', languageName: 'Dansk' },
	{ locale: 'pt', languageCode: 'pt', countryCode: 'PT', languageName: 'Portuguesa' },
	{ locale: 'pl', languageCode: 'pl', countryCode: 'PL', languageName: 'Polski' },
	{ locale: 'ro', languageCode: 'ro', countryCode: 'RO', languageName: 'Română' },
	{ locale: 'el', languageCode: 'el', countryCode: 'GR', languageName: 'Ελληνικά' },
	{ locale: 'uk', languageCode: 'uk', countryCode: 'UA', languageName: 'Українська' },
	{ locale: 'hu', languageCode: 'hu', countryCode: 'HU', languageName: 'Magyar' },
	{ locale: 'fi', languageCode: 'fi', countryCode: 'FI', languageName: 'Suomi' },
	{ locale: 'et', languageCode: 'et', countryCode: 'EE', languageName: 'Eesti' },
	{ locale: 'lv', languageCode: 'lv', countryCode: 'LV', languageName: 'Latviešu' },
	{ locale: 'lt', languageCode: 'lt', countryCode: 'LT', languageName: 'Lietuvių' },
	{ locale: 'cs', languageCode: 'cs', countryCode: 'CZ', languageName: 'Čeština' },
	{ locale: 'hr', languageCode: 'hr', countryCode: 'HR', languageName: 'Hrvatski' },
	{ locale: 'sl', languageCode: 'sl', countryCode: 'SI', languageName: 'Slovenščina' },
	{ locale: 'sk', languageCode: 'sk', countryCode: 'SK', languageName: 'Slovenčina' },
	{ locale: 'ca', languageCode: 'ca', countryCode: null, languageName: 'Català' },
];

export const enUs = {
	locale: 'en-us',
	languageCode: 'en',
	countryCode: 'US',
	languageName: 'English (US)',
	regionName: 'United States',
};
